/**
 * exportHelpers.ts
 *
 * Reusable utilities for safe, paginated data export.
 * Instead of fetching 99 999 records in a single API call we
 * send requests in batches (EXPORT_BATCH_SIZE rows per call)
 * and merge the results before triggering the XLSX download.
 */
/** How many records to request per page during an export fetch */
export const EXPORT_BATCH_SIZE = 500;
/**
 * Generic paginated-fetch loop.
 *
 * @param fetcher  - An async function that accepts `(page, limit)` and returns
 *                   `{ items: T[]; totalPages: number }`.
 * @returns        All items gathered across all pages.
 */
export async function fetchAllPages(fetcher) {
    const firstBatch = await fetcher(1, EXPORT_BATCH_SIZE);
    const all = [...firstBatch.items];
    const { totalPages } = firstBatch;
    // Fetch remaining pages in sequence to avoid flooding the server
    for (let p = 2; p <= totalPages; p++) {
        const batch = await fetcher(p, EXPORT_BATCH_SIZE);
        all.push(...batch.items);
    }
    return all;
}
